/**
 * La proposition du champion faite d'avance (« <champion> propose », sur un signal du live) : chaque appel à
 * l'endpoint de génération se compte dans les traces de la salle (le même `EngineTelemetry` que `useTutorLiveTraces`),
 * pour en mesurer le coût avant de l'élargir (arbitrage 5 : bornée, et son coût mesuré). `requested` porte le compte
 * des appels partis depuis l'entrée dans la salle ; `ready` et `failed` leur durée.
 *
 * Hors de `useTutorLiveTraces` : ce module-là charge `livekit-client`, que les tests du fil n'ont pas à charger.
 */
import { type EngineTelemetry, type TelemetryData } from "../../shared/telemetry"

export function traceHelperProposal(
    telemetry: EngineTelemetry,
    phase: "requested" | "ready" | "failed" | "sent" | "dismissed",
    data: TelemetryData
): void {
    telemetry.transition("helper_proposal", phase, "helper_proposal", data)
}
